import { render, staticRenderFns } from "./ButtonLeftPanel.vue?vue&type=template&id=63650a4f"
import script from "./ButtonLeftPanel.vue?vue&type=script&lang=js"
export * from "./ButtonLeftPanel.vue?vue&type=script&lang=js"
import style0 from "./ButtonLeftPanel.vue?vue&type=style&index=0&id=63650a4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports